<template>
  <div class="history">
    <div class="title">企业历程</div>
    <div class="steps">
      <div class="divider"></div>
      <div class="step-box">
        <div :class="activeStep === 2024 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2024">
          <div class="label">2024</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2023 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2023">
          <div class="label">2023</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2022 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2022">
          <div class="label">2022</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2021 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2021">
          <div class="label">2021</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2020 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2020">
          <div class="label">2020</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2019 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2019">
          <div class="label">2019</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2018 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2018">
          <div class="label">2018</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2017 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2017">
          <div class="label">2017</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2016 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2016">
          <div class="label">2016</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2015 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2015">
          <div class="label">2015</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2014 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2014">
          <div class="label">2014</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2013 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2013">
          <div class="label">2013</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
        <div :class="activeStep === 2012 ? 'step-item-selected' : 'step-item-normal'" @click="activeStep=2012">
          <div class="label">2012</div>
          <div class="icon">
            <div class="center"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="milestone">
      <div v-for="item in milestone[2024-activeStep].list" class="milestone-item">
        <div class="month">{{ item.month }}</div>
        <div class="content">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import IntroductionBanner from './IntroductionBanner'
	export default {
		name: 'Introduction',
		components: {
      IntroductionBanner
		},
		data() {
			return {
        activeStep: 2024,
        milestone:[
        {
            year: 2024,
            list: [
              {
                id:'2024-0',
                month: '4月',
                title: 'MoPaaS 魔泊云获得吴文俊人工智能科学技术科技进步奖',
                url: ''
              },
              {
                id:'2024-1',
                month: '8月',
                title: 'MoPaaS 入驻上海昇思生态创新中心，共绘人工智能璀璨新画卷',
                url: ''
              },
              {
                id:'2024-2',
                month: '9月',
                title: '合作中国人工智能学会，共同主办2024第二届人工智能大模型技术高峰论坛《大模型AI应用技术和工程专题论坛》',
                url: ''
              }
            ]
          },
          {
            year: 2023,
            list: [
              {
                id:'2023-0',
                month: '6月',
                title: 'MoPaaS 魔泊云首批入驻上海昇思AI框架&大模型创新中心',
                url: ''
              }
            ]
          },
          {
            year: 2022,
            list: [
              {
                id:'2022-0',
                month: '10月',
                title: '昇腾AI创新大赛 上海&浙江赛区 银奖',
                url: ''
              }
            ]
          },
          {
            year: 2021,
            list: [
              {
                id:'2021-0',
                month: '10月',
                title: '鲲鹏应用创新大赛MoPaaS AI平台 荣获“优秀解决方案”',
                url: ''
              },
              {
                id:'2021-1',
                month: '6月',
                title: '加入腾讯云原生加速器加入腾讯云原生加速器',
                url: ''
              }
            ]
          },
          {
            year: 2020,
            list: [
              {
                id:'2020-0',
                month: '1月',
                title: '上海张江国际人工智能挑战赛进入半决赛',
                url: ''
              }
            ]
          },
          {
            year: 2019,
            list: [
              {
                id:'2019-0',
                month: '12月',
                title: '成功入选微软云Co-sell联合销售计划',
                url: ''
              },
              {
                id:'2019-1',
                month: '10月',
                title: '成功入选VMware创新网络(VIN) “威睿加速计划”',
                url: ''
              }
            ]
          },
          {
            year: 2018,
            list: [
              {
                id:'2018-0',
                month: '7月',
                title: '获得2018“创客中国”智慧工厂创新创业大赛十强企业',
                url: ''
              },
              {
                id:'2018-1',
                month: '6月',
                title: '赞助主办第八届中国开源云计算黑客松大赛 PaaS 部分',
                url: ''
              },
              {
                id:'2018-2',
                month: '5月',
                title: 'MoPaaS 获选 GMIC 北京峰会 G-Startup 10 强创新企业\nMoPaaS 获选参加英国皇家“龙门创将”创新创业中国区大赛',
                url: ''
              },
              {
                id:'2018-3',
                month: '4月',
                title: '获得中国发明专利：一个智能化 PaaS 平台系统，这个也是中国首个 含PaaS关键字的发明专利\n资助主办第一届“MoPaaS杯清华大学人工智能挑战赛”',
                url: ''
              },
              {
                id:'2018-5',
                month: '3月',
                title: '发布 MoPaaS 人工智能技术服务平台，并落地清华大学 iCenter',
                url: ''
              },
            ]
          },
          {
            year: 2017,
            list: [
              {
                id:'2017-0',
                month: '9月',
                title: '获得第五届全球云计算大会中国领先品牌奖',
                url: ''
              },
              {
                id:'2017-1',
                month: '4月',
                title: '获得中国金融交易技术大会金融行业PaaS 平台最佳解决方案奖',
                url: ''
              },
              {
                id:'2017-2',
                month: '3月',
                title: '成功入选第九期微软加速器成员，成为微软Azure 的深度合作伙伴',
                url: ''
              }
            ]
          },
          {
            year: 2016,
            list: [
              {
                id:'2016-0',
                month: '10月',
                title: 'MoPaaS 获得 B轮融资，投资方：Walden(开物)/马力等投资',
                url: ''
              },
              {
                id:'2016-1',
                month: '9月',
                title: '参展 CloudConnect-China，MoPaaS 企业版获得全球创新产品云鼎奖',
                url: ''
              },
              {
                id:'2016-2',
                month: '1月',
                title: '成为阿里云合计划中唯一的 PaaS 和容器云服务深度合作伙伴',
                url: ''
              }
            ]
          },
          {
            year: 2015,
            list: [
              {
                id:'2015-0',
                month: '12月',
                title: '被 Forrester 评为中国企业云计算市场 Strong Performer',
                url: ''
              },
              {
                id:'2015-1',
                month: '9月',
                title: '参展 CloudConnect-China：获最具发展潜力的云计算公司云鼎奖',
                url: ''
              },
              {
                id:'2015-2',
                month: '2月',
                title: 'MoPaaS 企业版本正式发布',
                url: ''
              }
            ]
          },
          {
            year: 2014,
            list: [
              {
                id:'2014-0',
                month: '12月',
                title: '获得 A轮融资，投资方：马力创投、Incubic 和艾然鼎泰\n成为 Cloud Foundry 基金会创始会员，也是中国首个会员',
                url: ''
              },
              {
                id:'2014-2',
                month: '6月',
                title: '获得首个企业私有云平台订单',
                url: ''
              }
            ]
          },
          {
            year: 2013,
            list: [
              {
                id:'2013-0',
                month: '6月',
                title: '正式提供公有云 PaaS\n获得中国云计算大会十大云创新企业称号',
                url: ''
              },
              {
                id:'2013-2',
                month: '2月',
                title: 'MoPaaS 核心技术专利申请，中科院查新结论：技术达到国内领先水平',
                url: ''
              }
            ]
          },
          {
            year: 2012,
            list: [
              {
                id:'2012-0',
                month: '12月',
                title: 'MoPaaS基于开源的Cloud Foundry 云平台技术打造中国首个开放的公有云PaaS服务，并正式上线公测\n赞助主办第八届中国开源云计算黑客松大赛 PaaS 部分',
                url: ''
              }
            ]
          }
        ]
      }
		}
	}
</script>

<style>
  .history {
    padding: 120px 260px;
    background: #F5F6F9;
  }
  .history .title {
    width: 120px;
    height: 34px;
    font-size: 30px;
    font-weight: 500;
    color: #3A3F4D;
    line-height: 34px;
    margin: 0 auto;
  }
  .history .steps {
    margin-top: 58px;
    position: relative;
  }
  .history .steps .divider {
    width: 93%;
    height: 2px;
    background: #3263FF;
    opacity: 0.36;
    margin: 70px auto 0;
    display: inline-block;
  }
  .history .step-box {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: absolute;
    top: 0;
  }
  .history .steps .step-item-normal {
    cursor: pointer;
  }
  .history .steps .step-item-selected {
    cursor: pointer;
  }
  .history .steps .step-item-selected .label {
    width: 82px;
    height: 26px;
    font-size: 34px;
    font-weight: 600;
    color: #3263FF;
    line-height: 26px;
  }
  .history .steps .step-item-normal .label {
    width: 67px;
    height: 26px;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    opacity: 0.48;
  }
  .history .steps .step-item-normal .icon {
    width: 14px;
    height: 14px;
    border: 2px solid #95EFFF;
    border-radius: 16px;
    padding: 6px;
    background: #F5F6F9;
    margin: 30px auto 0;
  }
  .history .steps .step-item-selected .icon {
    width: 14px;
    height: 14px;
    border: 2px solid #3263FF;
    border-radius: 16px;
    padding: 6px;
    background: #3263FF;
    margin: 30px auto 0;
  }
  .history .steps .step-item-normal .icon .center {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: #3263FF;
  }
  .history .steps .step-item-selected .center {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: #FFFFFF;
  }
  .milestone {
    margin: 73px 13.54% 0;
    overflow-y: hidden;
  }
  .milestone .milestone-item {
    height: 144px;
    background-color: #FFFFFF;
    padding: 0 50px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 auto 32px;
  }
  .milestone .milestone-item .month {
    width: 186px;
    height: 72px;
    font-size: 72px;
    font-weight: 600;
    color: #333333;
    line-height: 72px;
    text-align: left;
    opacity: 0.15;
  }
  .milestone .milestone-item .content {
    font-size: 22px;
    font-weight: 400;
    color: #333333;
    line-height: 38px;
    white-space: pre-line;
    text-align: left;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/History.vue